var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Single',{attrs:{"service":"Users","sanitize":_vm.sanitize},on:{"initialized":_vm.setTitle},scopedSlots:_vm._u([{key:"default",fn:function({ value, listeners }){return [_c('User',_vm._g({staticClass:"pa-4",attrs:{"value":value}},listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }